export default __webpack_public_path__ + "static/media/1600.f8e22356.png";